import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, tap, catchError } from 'rxjs/operators';
import { InvestigationsRepository } from '../../../infrastructure/repositories/investigations.repository';
import { InvestigationsState } from '../../states/investigations.state';

export interface AddInvestigationMessageCommand {
  readonly investigationId: string;
  readonly messageType: number;
  readonly body: string;
}
export interface AddInvestigationMessageResult { messageId: string; }

@Injectable({ providedIn: 'root' })
export class AddInvestigationMessageUseCase {
  private readonly _repository = inject(InvestigationsRepository);
  private readonly _state = inject(InvestigationsState);

  public execute(command: AddInvestigationMessageCommand): Observable<AddInvestigationMessageResult> {
    this._state.setAddingMessage(true);
    this._state.setErrorMessages(null);
    return this._repository.addMessage(command.investigationId, command.messageType, command.body).pipe(
      tap(() => { this._state.setAddingMessage(false); }),
      map((response) => ({ messageId: response.id })),
      catchError((error) => {
        this._state.setErrorMessages(error.message || 'Failed to add message');
        this._state.setAddingMessage(false);
        return throwError(() => error);
      }),
    );
  }
}
